import { Button, Loader } from '@kanda-libs/ks-design-library';

import CommissionCheckbox from './CommissionCheckbox';
import useRepaymentInfo from './useRepaymentInfo';

const RepaymentInfo: React.FunctionComponent = function () {
  const {
    rate,
    showRepaymentInfo,
    title,
    subtitle,
    monthlyPayment,
    showDepositPayment,
    depositPayment,
    depositTitle,
    amountToFinance,
    totalInterest,
    totalRepayment,
    disabled,
    isSubmitting,
  } = useRepaymentInfo();
  if (!showRepaymentInfo) return null;
  return (
    <>
      <div className="mt-8" />
      <h2 className="text-16-24-b md:text-20-24-b mb-2 md:mb-6">
        Your selected finance plan
      </h2>
      <div className="grid grid-cols-[auto_min-content] p-4 md:p-6 border-2 shadow-lg border-neutral-300 bg-neutral-000 rounded-xl">
        <p className="text-16-24-em text-neutral-800 mb-1 col-span-2">
          {title}
        </p>
        {subtitle && (
          <p className="text-12-18 md:text-14-22 text-neutral-700 mb-1 col-span-2">
            {subtitle}
          </p>
        )}
        <div className="my-3 md:my-4 border-b border-neutral-300 col-span-2" />
        <p className="text-14-22-b md:text-16-24-b text-neutral-700 my-auto">
          Monthly Repayment
        </p>
        <p className="text-20-24-em md:text-24-28-em my-auto text-right">
          {monthlyPayment}
        </p>
        <div className="my-3 md:my-4 border-b border-neutral-300 col-span-2" />
        {showDepositPayment && (
          <>
            <p className="text-12-18 md:text-14-22 text-neutral-700 my-auto">
              {depositTitle}
            </p>
            <p className="text-14-22-b md:text-16-24-b my-auto text-right">
              {depositPayment}
            </p>
          </>
        )}
        <p className="text-12-18 md:text-14-22 text-neutral-700 my-auto">
          Amount to finance
        </p>
        <p className="text-14-22-b md:text-16-24-b my-auto text-right">
          {amountToFinance}
        </p>
        <p className="text-12-18 md:text-14-22 text-neutral-700 my-auto">
          Total interest
        </p>
        <p className="text-14-22-b md:text-16-24-b my-auto text-right">
          {totalInterest}
        </p>
        <div className="my-3 md:my-4 border-b border-neutral-300 col-span-2" />
        <p className="text-14-22-b md:text-16-20-b text-neutral-700 my-auto">
          Total payable
        </p>
        <p className="text-16-20-b md:text-18-22-b my-auto text-right">
          {totalRepayment}
        </p>
        {rate && (
          <>
            <CommissionCheckbox selectedRate={rate} />
            <Button.Text
              submit
              disabled={disabled || isSubmitting}
              id="finance-apply-now"
              label={
                <div className="flex flex-row">
                  <span className="my-auto mr-2">Apply for finance</span>
                </div>
              }
              variant="gradient"
              icon="arrow-right"
              className="w-full col-span-2 mt-4"
            />
          </>
        )}
        <Loader isLoading={isSubmitting} />
      </div>
    </>
  );
};

export default RepaymentInfo;
